// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html{height:100vh;width:100vw;overflow:hidden}body{height:100vh;width:100vw;overflow:hidden}.app{display:flex;width:100vw;height:100vh}.app-default{width:100%;height:100%;display:flex;transition:all 0.2s ease}.app-default-ww{height:calc(100% - 64px);margin-top:64px}.app-body{position:relative;flex:1;display:flex;flex-direction:column;overflow:hidden;scroll-behavior:smooth}#upload-file-input,#create-new-domain{position:absolute;visibility:hidden;width:0;height:0 !important}\n", ""]);
// Exports
module.exports = exports;
